import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetCertificationList = (userId) => {
  const data = useQuery(
    ["certificationList", userId],
    () =>
      axiosClient.get(
        `/DocumentType/GetCertificationsList?userId=${userId}`
      ),
  );

  return data;
};
export default useGetCertificationList;